import { useTranslation } from 'react-i18next';
import { useProfilePathways } from '../../../hooks';
import React from 'react';
import { NoItemView, PathwaysBox } from '../../../components';
import './PathwaysViewContent.css';
import { inIframe } from '../../../utils';

interface PathwaysViewContentProps {
  username: string;
}

export const PathwaysViewContent: React.FC<PathwaysViewContentProps> = ({
  username,
}) => {
  const { userPathways, userPathwaysLoaded } = useProfilePathways(username);
  const { t } = useTranslation('library');

  return (
    <span>
      <div
        className="ov_panel active"
        data-name="p"
        style={{ marginTop: '20px' }}
      >
        <div className="br_cont">
          <div className="div-block-483">
            <div className="text-block-278">{t('My Pathways')}</div>
          </div>
          <div className="br_row">
            <PathwaysBox
              userPathways={userPathways}
              userPathwaysLoaded={userPathwaysLoaded}
              username={username}
            ></PathwaysBox>

            {userPathways?.length === 0 && userPathwaysLoaded && inIframe() && (
              <NoItemView
                displayMessage={`${username} ${t(
                  "hasn't created any pathways yet."
                )}`}
                imageUrl={'/images/tools.png'}
                displayPadding={true}
              />
            )}
          </div>
        </div>
      </div>
    </span>
  );
};
